var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09984 18.1067L9.1665 13.3333L6.09984 8.56L11.5932 10L15.1665 5.61333L15.5132 11.28L20.7665 13.3333L15.5132 15.3867L15.1665 21.0533L11.5932 16.6667M12.4998 24C13.2071 24 13.8854 24.281 14.3855 24.781C14.8856 25.2811 15.1665 25.9594 15.1665 26.6667L20.4998 26.6667C21.2071 26.6667 21.8854 26.3857 22.3855 25.8856C22.8856 25.3855 23.1665 24.7072 23.1665 24L23.1665 2.66667C23.1665 1.95942 22.8856 1.28115 22.3855 0.781048C21.8854 0.280951 21.2071 -8.56491e-08 20.4998 -1.16564e-07L15.1665 -3.49691e-07C15.1665 0.707244 14.8856 1.38552 14.3855 1.88562C13.8854 2.38571 13.2071 2.66667 12.4998 2.66667C11.7926 2.66667 11.1143 2.38571 10.6142 1.88562C10.1141 1.38552 9.83317 0.707243 9.83317 -5.82819e-07L4.49984 -8.15946e-07C3.79259 -8.46861e-07 3.11432 0.280951 2.61422 0.781048C2.11412 1.28114 1.83317 1.95942 1.83317 2.66667L1.83317 24C1.83317 24.7072 2.11412 25.3855 2.61422 25.8856C3.11432 26.3857 3.79259 26.6667 4.49983 26.6667L9.83317 26.6667C9.83317 25.9594 10.1141 25.2811 10.6142 24.781C11.1143 24.281 11.7926 24 12.4998 24Z",
    fill: "#FF29D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.c405038854ffc3700792767010f0c797.svg";
export { ForwardRef as ReactComponent };